import { render, staticRenderFns } from "./ClaimWithoutReserves.vue?vue&type=template&id=7335dee0&"
import script from "./ClaimWithoutReserves.vue?vue&type=script&lang=js&"
export * from "./ClaimWithoutReserves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports